import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateMyQuery = (queryKey: string) => {
  const queryClient = useQueryClient();

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  };

  return invalidate;
};
